// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UBdOv","field":"styles_field__N-eDS","fieldCol":"styles_fieldCol__vI4we","diffCol":"styles_diffCol__22TUn","diff":"styles_diff__1D4Xq"};